module.exports = __webpack_public_path__ + "static/media/NMMA Advocacy Year-in-Review.docx.e43cf932.";